import React from 'react'
import { Typography } from '../../../index'
import styles from './styles.module.css'
import { cn, type UtilityClassNames } from '@s4l/utility-css'

export interface TabProps {
  title: string
  description?: React.ReactNode
  className?: UtilityClassNames
  onClick?: () => void
  hidden?: boolean
  disabled?: boolean
  selected?: boolean
}

const Tab = React.forwardRef<HTMLLIElement, TabProps>(
  (
    { title, description, className, onClick, hidden, disabled = false, selected = false, ...rest },
    ref
  ) => {
    if (hidden) return null

    const classNames = cn(
      styles.tab,
      styles[selected ? 'selected' : ''],
      styles[disabled ? 'disabled' : ''],
      className
    )

    return (
      <li ref={ref} className={styles.container} {...rest}>
        <button
          className={classNames}
          role="tab"
          tabIndex={selected ? 0 : -1}
          type="button"
          aria-selected={selected}
          aria-disabled={disabled}
          onClick={selected ? undefined : onClick}
        >
          <Typography variant="caption" size="l" bold>
            {title}
          </Typography>
          {description && (
            <Typography variant="body" size="l" bold>
              {description}
            </Typography>
          )}
        </button>
      </li>
    )
  }
)

export default Tab
